import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { DateUtil } from "./../../fxms/datas/DateUtil";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import highchartsMore from "highcharts/highcharts-more.js";
import Pareto from 'highcharts/modules/pareto';
import Modal from "@mui/material/Modal";

highchartsMore(Highcharts);
Pareto(Highcharts);

/* 실시간 전력 사용현황 */
export const FxIndcManagerChartPareto = forwardRef((props, ref) => {
  const { energy, dataToday, dataBefor } = props;
  const [openDetailView, setOpenDetailView] = useState(false);
  useImperativeHandle(ref, () => ({
    openDetail: () => setOpenDetailView(true),
    closeDetail: () => setOpenDetailView(false),
  }));


  const getData = (values) => {
    let data = [];
    if (values && Object.keys(values).length !== 0) {
      for (const value of values) {
        data.push([
          DateUtil.makeDate(
            "19700101" + value.psDate.toString().substr(8, 6)
          ).getTime(),
          value.consAmt,
        ]);
      }
    } else {
      data.push([DateUtil.makeDate().getTime(), 0, DateUtil.makeDate().getTime()]);
    }

    data.sort((a, b) => a[0] - b[0]);

    return data;
  }

  const getChartData = (title, isDetail = false) => {
    return {
      title: {
        text: title,
        align: "center",
      },

      tooltip: {
        crosshairs: true,
        shared: true,
        formatter: function () {
        const time = new Date(this.x).toLocaleTimeString('ko-KR', { hour: 'numeric', minute: 'numeric', hour12: true });
          return ['<b>' + time + '</b><br>'].concat(
            this.points ?
              this.points.map(function (point) {
                return '<b>'+point.series.name+'</b>' + ': ' + Math.round(point.y).toLocaleString("ko-KR") + ' kWh <br>';
              }) : []
          );
        },
      },
      plotOptions: {
        series: {
          animation: false,
          cursor: 'pointer',
          marker: {
            lineWidth: 1
          },
          point: {
            events: {
              click: () => setOpenDetailView(true),
            }
          }
        }
      },
      series: [
        {
          name: '당일',
          type: 'line',
          data: getData(dataToday),
          tooltip: {
            valueSuffix: 'kWh'
          },
        },
        {
          name: '전일',
          type: 'spline',
          data: getData(dataBefor || []),
          tooltip: {
            valueSuffix: 'kWh'
          },
          marker: {
            fillColor: "black",
            lineWidth: 1,
            lineColor: "grey",
          },
          visible: isDetail,
        },

      ],
      xAxis: {
        type: "datetime",
        labels: {
          style: {
            color: "rgba(255,255,255,0.8)"
          },
          formatter: function () {
            return new Date(this.value).toLocaleTimeString('ko-KR', { hour: "numeric", hour12: false });
          }
        },
      },
      yAxis: {
        title: {
          text: null,
        },
        lineWidth: 1,
        lineColor: '#3e3e3e',
        gridLineColor: '#3e3e3e'
      },
      chart: {
        height: isDetail ? 320 : 200,
        backgroundColor: "#313131",
        borderWidth: 1,
        borderRadius: 0,
        borderColor: "#303030",
        plotBackgroundColor: "#303030",
        plotBorderWidth: 1,
        plotBorderColor: "#303030"
      }
      ,
      // legend: {
      //   align: 'left',
      //   x: 60,
      //   verticalAlign: 'top',
      //   y: 1,
      //   floating: true,
      //   backgroundColor: 'grey'
      // }

      legend: {
        enabled: isDetail,
      },
    };
  }

  useEffect(() => {
    const values1 = dataToday;
    const values2 = dataBefor;
    if (values1 === undefined || values2 === undefined) {
      return;
    }
  }, [dataToday, dataBefor, energy])

  return (
    <>
      <div onClick={() => setOpenDetailView(true)}>
        <HighchartsReact
          highcharts={Highcharts}
          options={getChartData('')}
        />
      </div>
      <Modal
        open={openDetailView}
        onClose={() => setOpenDetailView(false)}
        className="detail-chart-modal"
      >
        <div className="detail-chart-container">
          <div className="predict" style={{ height: "100%" }}>
            <div className="vupNewLayerPop">
              <div className="lpopTitle">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "100%",
                    padding: "0 20px",
                  }}
                >
                  <h3>실시간 전력 사용 상세 (15분)</h3>
                  <div
                    className="closeBtn"
                    onClick={() => setOpenDetailView(false)}
                  >
                    <img src="../svgCloseBtn_on.svg" />
                    <img src="../svgCloseBtn.svg" />
                  </div>
                </div>
              </div>
              <div
                className="lpopContent detail-chart"
                style={{ height: "calc(100% - 40px)" }}
              >
                <HighchartsReact
                  highcharts={Highcharts}
                  options={getChartData("실시간 전력 사용현황", true)}
                />
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );

});

FxIndcManagerChartPareto.displayName = "FxIndcManagerChartPareto";
